import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

/**
 * ProtectedRoute Component
 *
 * Restricts access to routes that require authentication.
 * - If the user is authenticated, renders the child components.
 * - If not authenticated, redirects to the login page.
 * - While authentication is being checked, shows a loading spinner.
 *
 * @component
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The component(s) to render if authenticated
 *
 */
const ProtectedRoute = ({ children }) => {
  const { userToken, isLoading } = useSelector((state) => state.global);
  const location = useLocation();

  // Show loading state while verifying authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Redirect unauthenticated users to login page
  if (!userToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Render children if authentication is successful
  return children;
};

export default ProtectedRoute;
